<script setup lang="ts">
import DxTabPanel, { DxItem as DxTabItem } from 'devextreme-vue/tab-panel';
import { EntityListPage, type EntityConfig } from '@botto/core';
import CdpPageShell from '../components/CdpPageShell.vue';
import TransitionsEditor from '../features/transitions/TransitionsEditor.vue';
import {
  partnerLinksStore,
  postbackGoalsStore,
  type PartnerLink,
  type PostbackGoalConfig,
} from '../api';
import { useCdpProjectContext } from '../composables/useCdpProjectContext';

const { selectedProjectId } = useCdpProjectContext();

const postbackGoalConfig: EntityConfig<PostbackGoalConfig> = {
  title: 'Postback goal',
  titlePlural: 'Postback goals',
  keyExpr: 'id',
  popupWidth: 480,
  columns: [
    { dataField: 'goal', caption: 'Goal' },
    { dataField: 'message_id', caption: 'Message ID' },
    { dataField: 'phone_attr', caption: 'Phone attr' },
  ],
  fields: [
    { dataField: 'goal', label: 'Goal', required: true, createOnly: true },
    { dataField: 'goal', label: 'Goal', editOnly: true, editorOptions: { readOnly: true } },
    { dataField: 'message_id', label: 'Message ID' },
    { dataField: 'phone_attr', label: 'Phone attr' },
  ],
};

const partnerLinkConfig: EntityConfig<PartnerLink> = {
  title: 'Partner link',
  titlePlural: 'Partner links',
  keyExpr: 'id',
  popupWidth: 520,
  columns: [
    { dataField: 'partner_key', caption: 'Partner key' },
    { dataField: 'landing_ref_link', caption: 'Landing' },
    { dataField: 'app_ref_link', caption: 'App' },
  ],
  fields: [
    { dataField: 'partner_key', label: 'Partner key', required: true, createOnly: true },
    {
      dataField: 'partner_key',
      label: 'Partner key',
      editOnly: true,
      editorOptions: { readOnly: true },
    },
    { dataField: 'landing_ref_link', label: 'Landing ref link', colSpan: 2 },
    { dataField: 'app_ref_link', label: 'App ref link', colSpan: 2 },
  ],
};
</script>

<template>
  <CdpPageShell title="Retention-правила">
    <DxTabPanel class="retention-tabs">
      <DxTabItem title="Transitions">
        <TransitionsEditor :key="`tr-${selectedProjectId ?? ''}`" :project-id="selectedProjectId" />
      </DxTabItem>

      <DxTabItem title="Postback goals">
        <EntityListPage
          :key="`pg-${selectedProjectId ?? ''}`"
          embedded
          :config="postbackGoalConfig"
          :store="postbackGoalsStore"
        />
      </DxTabItem>

      <DxTabItem title="Partner links">
        <EntityListPage
          :key="`pl-${selectedProjectId ?? ''}`"
          embedded
          :config="partnerLinkConfig"
          :store="partnerLinksStore"
        />
      </DxTabItem>
    </DxTabPanel>
  </CdpPageShell>
</template>

<style scoped>
.retention-tabs {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.retention-tabs :deep(.dx-tabpanel-container),
.retention-tabs :deep(.dx-multiview-wrapper),
.retention-tabs :deep(.dx-multiview-item) {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
}

.retention-tabs :deep(.dx-multiview-item-content) {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  padding: 8px 0 0;
}

.retention-tabs :deep(.entity-list-page),
.retention-tabs :deep(.botto-panel) {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
}
</style>
